// extracted by mini-css-extract-plugin
export default {"BlogDetails":"blog-details_BlogDetails__W63DR"};